import { AxiosResponse } from 'axios'
import { RoutingApi } from 'conversations/api'
import { Rule } from 'shared/typings/rules/Rule'

interface onCallResponse {
  lastUpdatedBy: number
  userIds: number[]
}

interface RulesResponseV2 {
  onCall: onCallResponse
  rules: Rule[]
}

export const fetchRules = async (): Promise<Rule[]> => {
  const { data }: AxiosResponse<RulesResponseV2> = await RoutingApi.get('/rules/all')
  return data.rules
}
